import { cn } from "@boveda/shared";
import { AppSidebar } from "@/components/app-sidebar";
import { AccountSwitcherHost } from "@/features/auth/account-switcher-host";

interface AppLayoutSidebarProps {
  isOpen: () => boolean;
  setOpen: (open: boolean) => void;
}

export function AppLayoutSidebar(props: AppLayoutSidebarProps) {
  return (
    <>
      {/* ── Mobile Sidebar Drawer ───────────────────────────────── */}
      <div
        class={cn(
          "fixed inset-0 z-[100] overflow-hidden transition-all duration-300 ease-swift lg:hidden",
          props.isOpen() ? "pointer-events-auto" : "pointer-events-none",
        )}
      >
        <button
          type="button"
          onClick={() => {
            props.setOpen(false);
          }}
          class={cn(
            "absolute inset-0 h-full w-full cursor-default border-none bg-black/40 p-0 backdrop-blur-[2px] transition-opacity duration-300 ease-swift",
            props.isOpen() ? "opacity-100" : "opacity-0",
          )}
          // eslint-disable-next-line lingui/no-unlocalized-strings -- decorative backdrop, label is a11y fallback
          aria-label="Close sidebar"
        />
        <aside
          class={cn(
            "absolute bottom-0 left-0 top-0 flex w-[280px] flex-col border-r border-border/40 bg-card/85 shadow-2xl backdrop-blur-md transition-transform duration-300 ease-swift will-change-transform",
            "pb-[var(--safe-area-inset-bottom)] pl-[var(--safe-area-inset-left)]",
          )}
          style={{
            transform: props.isOpen() ? "translate3d(0, 0, 0)" : "translate3d(-100%, 0, 0)",
          }}
        >
          <AppSidebar
            onCloseSidebar={() => {
              props.setOpen(false);
            }}
          />
        </aside>
      </div>

      {/* ── Desktop Sidebar ───────────────────────────────────── */}
      <aside class="hidden w-64 shrink-0 flex-col border-r border-border/40 bg-card/10 backdrop-blur-md lg:flex">
        <AppSidebar />
      </aside>

      <AccountSwitcherHost />
    </>
  );
}
